/**
 * Cross-app URL helper for the v2 RBAC topbar app switcher.
 *
 * Reads webpack DefinePlugin-injected globals (see
 * `config/webpack.config.ts/plugins.ts`). Returns null when a URL isn't
 * configured so the AppSwitcher can degrade gracefully (hide that item).
 */

export type AppId =
  | 'admin_hub'
  | 'market_analyzer'
  | 'data_studio'
  | 'sales_copilot'
  | 'ai_sales_copilot';

export function getAppUrl(
  appId: AppId,
  options: { tenantId: string | null }
): string | null {
  const { tenantId } = options;

  switch (appId) {
    case 'admin_hub': {
      if (!NEW_ADMIN_BASE_URL) return null;
      const base = NEW_ADMIN_BASE_URL.replace(/\/$/, '');
      return tenantId ? `${base}/org/${tenantId}` : base;
    }
    case 'market_analyzer': {
      if (!MARKET_BASE_URL) return null;
      return MARKET_BASE_URL.replace(/\/$/, '');
    }
    case 'data_studio': {
      // Same-origin; clicking the current app no-ops. Provided so callers
      // can render it as the current/active item.
      return tenantId ? `/tenant/${tenantId}` : '/';
    }
    case 'sales_copilot': {
      if (!COPILOT_BASE_URL) return null;
      return COPILOT_BASE_URL.replace(/\/$/, '');
    }
    case 'ai_sales_copilot': {
      if (!AI_COPILOT_BASE_URL) return null;
      return AI_COPILOT_BASE_URL.replace(/\/$/, '');
    }
    default:
      return null;
  }
}
